import { config } from '../../../config';
import { createStore } from '../../_core/createStore';
import { lazyDependency } from '../../_core/lazyDependency';
import useApiStore from '../../apiStore/useApiStore';
import { submissionStatusStore } from './submissionStatusStore';

const useSubmissionStatusStore = createStore({
  creator: submissionStatusStore({
    config,
    useApiStore: lazyDependency(() => useApiStore),
  }),
  id: 'submissionStatus',
  middlewares: {
    devtools: true,
  },
});

export default useSubmissionStatusStore;
